import React, { Suspense, useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { callCommonAction } from './redux/Common/CommonReducer';
import { sendRequest } from './apis/APIs';
import UserRoute from './routes/UserRoute';
import 'bootstrap/dist/css/bootstrap.min.css';
import appRoutes from './configs/AppRoutes';
import './css/custom.css';




function App() {
  const dispatch = useDispatch();
  const { isLoggedIn, user } = useSelector((state) => state.common);
  
  useEffect(() => {

    if (localStorage.token !== undefined && localStorage?.token !== null) {
      dispatch(callCommonAction({
        isLoggedIn: true,
        token: localStorage?.token,
        user: JSON.parse(localStorage?.user),
      }));
    }
    else {
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
  }, [isLoggedIn]);

  return (

    <BrowserRouter>
      <ToastContainer autoClose={1500} />
      <Suspense>
        <UserRoute />
      </Suspense>
    </BrowserRouter>

  );
}

export default App;
